<!--
    House outline for the HOME chip (Asana 1217333292818343, Figma 4933-40092).
    Uses the same `.stroke` class contract as the other nav icons (see
    bottom-navigation.vue) so callers recolour it by styling `.stroke`, rather
    than this file hardcoding a colour.
-->
<template>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path
            class="stroke"
            d="M1.75 5.83 7 1.75l5.25 4.08V11.7a.58.58 0 0 1-.58.58H2.33a.58.58 0 0 1-.58-.58V5.83Z"
            stroke-width="1.5"
            stroke-linejoin="round"
        />
    </svg>
</template>
